import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const InternalVsExternalSupport3 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="internalVsExternalSupport" section="internal">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="internalVsExternalSupport:internal.advantages" />
            <SatelliteTopics t={props.t} prefix="internalVsExternalSupport:internal.challenges" noPadBottom />
        </div>
    </ServiceSection>
);

export default InternalVsExternalSupport3;
